const { render } = wp.element;
import UserManagementPage from "./UserManagementPage";
import TwoFAPreferences from './TwoFAPreferences';
import printJS from 'print-js';
import './index.scss';

const root = document.getElementById("um-root");
root && render(<UserManagementPage />, root);

const twofaRoot = document.getElementById("twofa-root");
twofaRoot && render(<TwoFAPreferences />, twofaRoot);
